import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Contractor, ContractorDocument } from '@umss/shared/data-access';

@Injectable({ providedIn: 'root' })
export class ContractorsService {
  private http = inject(HttpClient);

  private readonly baseUrl = 'api/contractors';

  get(id: string): Observable<Contractor> {
    return this.http.get<Contractor>(`${this.baseUrl}/${id}`);
  }

  getDocuments(id: string): Observable<ContractorDocument[]> {
    return this.http.get<ContractorDocument[]>(
      `${this.baseUrl}/${id}/documents`
    );
  }
}
